import { useState } from 'react';
import classNames from 'classnames';
import { Field, Text, Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentProps } from 'lib/component-props';
import SVG from 'helpers/SVG/SVG';
import RichTextA11yWrapper from 'helpers/RichTextA11yWrapper/RichTextA11yWrapper';

export type LocationBannerProp = {
  fields: LocationField;
} & ComponentProps;

export type LocationField = {
  ChooseLocation: Field<string>;
  Info: Field<string>;
  LocationName: Field<string>;
  DefaultLocation: Field<string>;
};

const LocationBanner = (props: LocationBannerProp) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const locationModal = `locationmodal`;
  if (!props?.fields) return <></>;

  const { ChooseLocation, Info, LocationName, DefaultLocation } = props?.fields || {};

  return (
    <section className="container spacing-md">
      <div
        tabIndex={0}
        onClick={() => {
          setIsModalOpen(!isModalOpen);
        }}
        className={classNames(
          'group w-full cursor-pointer flex relative p-4 border rounded overflow-hidden border-light-other-orange bg-light-background-location-gradient',
          'hover:border-[1.5px] hover:border-light-other-redVibrant',
          'focus:outline-[1.5px] focus:outline-light-stroke-primary-variant-highest focus:bg-light-background-location-gradient-focus'
        )}
      >
        <div className="flex justify-center items-center">
          <SVG
            className="absolute left-4 [&_svg]:h-[72px] [&_svg]:w-[72px] [&_svg]:sm:w-[88px] [&_svg]:sm:h-[88px] [&_svg]:lg:w-[100px] [&_svg]:lg:h-[100px]"
            svg="icon-location-selector"
          />
        </div>
        <div className="w-full ml-[88px] sm:ml-[96px] lg:ml-[108px] flex flex-col md:flex-row justify-between grow gap-x-2">
          <p className="p2 flex flex-wrap">
            <Text
              className={classNames('p2', 'group-hover:underline', 'group-focus:underline')}
              field={Info}
            />
            &nbsp;
            <div className="flex items-center gap-x-1">
              <RichTextA11yWrapper
                className={classNames(
                  'font-medium rtaw',
                  'group-hover:underline',
                  'group-focus:underline'
                )}
                field={LocationName?.value ? LocationName : DefaultLocation}
              />
              <SVG
                className="[&_svg]:h-4 [&_svg]:w-4 [&_svg]:sm:h-5 [&_svg]:sm:w-5 [&_svg]:lg:h-6 [&_svg]:lg:w-6"
                svg="icon-pin"
              />
            </div>
          </p>
          <div className="flex items-center gap-2 mt-3 md:mt-0">
            <Text
              className={classNames('p2-medium', 'group-hover:underline', 'group-focus:underline')}
              tag="span"
              field={ChooseLocation}
            />
            <SVG className="[&_svg]:h-5 [&_svg]:w-5" svg="icon-chevron-right" />
          </div>
        </div>
      </div>
      {props.rendering && (
        <Placeholder
          onModalClose={() => {
            setIsModalOpen(false);
          }}
          locationName={LocationName?.value ? LocationName?.value : DefaultLocation?.value}
          isModalOpen={isModalOpen}
          name={locationModal}
          rendering={props?.rendering}
        />
      )}
    </section>
  );
};
export default LocationBanner;
